import React, {Fragment} from 'react';
import {Grid} from '@material-ui/core';
import _ from 'lodash'
import styled from 'styled-components';
import {
  ChildSectionTitle,
  SideLabelTextWithRefInput,
  SideLabelTextAreaWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelPercentWithRefInput,
  SideLabelAutoCompleteInput,
  SideLabelMoneyWithRefInput,
  SecuritizedInput
 } from '../../FormSectionComponents';  

class PrepaymentTermsDefeasance extends React.Component {  
  
  renderSecuritizedInput = (formik) => {
    let dateComponents = formik.values.prepaymentTerms.securitizationDate ? formik.values.prepaymentTerms.securitizationDate.split("-") : '';
    if(dateComponents[1] && !formik.values.prepaymentTerms.securitizationMonth){
      formik.setFieldValue("prepaymentTerms.securitizationMonth",(dateComponents[1]-1).toString(),false);
      formik.setFieldValue("prepaymentTerms.securitizationYear",dateComponents[0],false);
    }
    return(
      <SecuritizedInput 
        formk={formik}
        label="Securitization"
        checkboxFieldName="Securitized "
        midLabel="Month: "
        isSecuritized={formik.values.prepaymentTerms.isSecuritized}
        securitizationDate={formik.values.prepaymentTerms.securitizationDate}
        isDisabled = {!this.props.isEditing}
        onChange = {(o) => {
          this.setState(o);
        }}
      />
    )
  }

  render(){    
    const {isEditing} = this.props;
    return (
      <Fragment>
         <SideLabelPercentWithRefInput
          label="Exit Fee"
          hasBorder
          placeholder="Exit Fee"
          fieldName="prepaymentTerms.exitFee"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Lockout Period"
          hasBorder
          placeholder="Lockout Period"
          fieldName="prepaymentTerms.lockoutPeriod"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Par Prepayment Period"
          hasBorder
          placeholder="Par Prepayment Period"
          fieldName="prepaymentTerms.parPrepaymentPeriod"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Notice Period"
          hasBorder
          placeholder="Notice Period"
          fieldName="prepaymentTerms.noticePeriod"
          isDisabled={!isEditing}/>          
        <SideLabelTextAreaWithRefInput
          label="Successor Borrower Designation"
          hasBorder
          placeholder="Successor Borrower Designation"
          fieldName="prepaymentTerms.successorBorrowerDesignation"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Defeasance Collateral"
          hasBorder
          placeholder="Defeasance Collateral"
          fieldName="prepaymentTerms.defeasanceCollateral"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Securities Structure"
          hasBorder
          placeholder="Securities Structure"
          fieldName="prepaymentTerms.securitiesStructure"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Portfolio Maturity"
          hasBorder
          placeholder="Portfolio Maturity"
          fieldName="prepaymentTerms.portfolioMaturity"
          isDisabled={!isEditing}/>  
          <SideLabelMoneyWithRefInput
          label="Defeasance Fee"
          hasBorder
          placeholder="Defeasance Fee"
          fieldName="prepaymentTerms.defeasanceFee"
          isDisabled={!isEditing}/> 
          <SideLabelMoneyWithRefInput
          label="Transfer Fee"
          hasBorder
          placeholder="Transfer Fee"
          fieldName="prepaymentTerms.transferFee"
          isDisabled={!isEditing}/> 
          {this.renderSecuritizedInput(this.props.formik)}
        <SideLabelTextAreaWithRefInput
          label="Other"
          placeholder="Other"
          fieldName="prepaymentTerms.other"
          isDisabled={!isEditing}/>  
      </Fragment>
  )};
}
export default PrepaymentTermsDefeasance;